export enum UserRole {
  Admin = 'admin',
  AuditReviewer = 'audit_reviewer',
  Auditor = 'auditor',
  Billing = 'billing',
  BillingAdmin = 'billing_admin',
  Care = 'care',
  Claims = 'claims',
  Collections = 'collections',
  DataCorrector = 'data_corrector',
  Dispatcher = 'dispatcher',
  Driver = 'driver',
  Engineering = 'engineering',
  EnterpriseManager = 'enterprise_manager',
  L1Agent = 'l1_agent',
  L2Agent = 'l2_agent',
  Manager = 'manager',
  Marketing = 'marketing',
  Mover = 'mover',
  OpsLeadership = 'ops_leadership',
  PartnershipManager = 'partnership_manager',
  Product = 'product',
  Recruiter = 'recruiter',
  Retention = 'retention',
  SelfStorageAssociate = 'self_storage_associate',
  Teamlead = 'teamlead',
  Tester = 'tester',
  Timekeeper = 'timekeeper',
  Warehouse = 'warehouse',
}
